import { AppDispatch, RootState } from '@redux/store';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { type Location, useLocation } from 'react-router-dom';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useAppLocation = <T>() => useLocation() as Location<T | null>;
